import usePreference from "./usePreference";

export const mainVisitSortingPreferenceOptions = [
  "Priority",
  "PostedDate",
  "StartDate",
  "Distance",
  "Price",
] as const;

export type MainVisitSortingPreference = (typeof mainVisitSortingPreferenceOptions)[number];

export default function useMainVisitSortingPreference() {
  return usePreference({
    id: "available-visits-sorting",
    options: mainVisitSortingPreferenceOptions,
    defaultOption: "Priority",
  });
}
